import React from 'react';

const Pillars = () => {
  return (
    <div className="pillars">
      <h1>Pillars</h1>
      <div className="pillars-content">
        {/* Pillars content will go here */}
      </div>
    </div>
  );
};

export default Pillars; 